import { FieldTypesObject } from './form_builder_iterfaces';
import {
    AttachMoney,
    CheckBox,
    DateRangeOutlined,
    DescriptionOutlined,
    Email,
    HMobiledataRounded,
    HorizontalRule,
    LinearScale,
    Numbers,
    PanoramaFishEye,
    Percent,
    Phone,
    RadioButtonUncheckedOutlined,
    StarOutlineRounded,
    Subject
} from '@mui/icons-material';

export const FIELD_TYPES: FieldTypesObject = {
    Text_Fields: [
        { type: 'heading', label: 'Headings', icon: <HMobiledataRounded /> },
        { type: 'description', label: 'Description', icon: <DescriptionOutlined /> }
    ],
    Input_Fields: [
        { type: 'text', label: 'Single Line Text', icon: <HorizontalRule /> },
        { type: 'multiline', label: 'Multiline Text', icon: <Subject /> },
        { type: 'email', label: 'Email', icon: <Email /> },
        { type: 'phone', label: 'Phone Number', icon: <Phone /> },
        { type: 'number', label: 'Number', icon: <Numbers /> },
        { type: 'decimal', label: 'Decimal', icon: <PanoramaFishEye /> },
        { type: 'percentage', label: 'Percentage', icon: <Percent /> },
        { type: 'currency', label: 'Currency', icon: <AttachMoney /> },
        { type: 'date', label: 'Date', icon: <DateRangeOutlined /> },
        { type: 'rating', label: 'Star Rating', icon: <StarOutlineRounded /> },
        { type: 'slider', label: 'Slider', icon: <LinearScale /> }
    ],
    Multiple_Choice: [
        { type: 'checkbox', label: 'Checkbox', icon: <CheckBox /> },
        { type: 'radio', label: 'Radio Button', icon: <RadioButtonUncheckedOutlined /> }
    ]
    // Media_Elements: [
    //     { type: 'file', label: 'Upload File', icon: <FileUploadOutlined /> },
    //     { type: 'image', label: 'Upload Image', icon: <InsertPhoto /> }
    // ]
};
